import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateEventComponent } from './create-event.component';

@NgModule({
  declarations: [CreateEventComponent],
  imports: [CommonModule],
  exports: [CreateEventComponent],
})
export class CreateEventModule {}
